import { RPE_INFORMATION_SCREEN_TAB_IDS } from 'src/app/shared/rpe/rpe-information-screen.constants';
import {
  RPE_INVALID_TAB_AND_LEGEND_ID,
  rpeTabFormScope,
} from 'src/app/shared/rpe/rpe-module.helper';
import { ActionIcons } from 'src/app/shared/utility/constants';

export const MAWB_RPE_MODULE_NAMES = ['MAWB'] as const;
export const MAWB_RPE_MODULE = MAWB_RPE_MODULE_NAMES[0];
export const MAWB_RPE_INVALID_TAB_AND_LEGEND_ID = RPE_INVALID_TAB_AND_LEGEND_ID;

/** API actionName for MAWB Publish (summary + information header button). */
export const MAWB_RPE_ACTION_PUBLISH = 'publish';

/** Nested MAWB↔Manifest link actions (MAWB Information manifest table). */
export const MAWB_RPE_ADD_MANIFEST_ACTION = 'add manifest';
export const MAWB_RPE_REMOVE_MANIFEST_ACTION = 'remove manifest';

/** Manifest table: Add/Delete icons map to nested link actions. */
export const MAWB_RPE_MANIFEST_TABLE_ICON_ACTION_OVERRIDES: Record<
  string,
  string
> = {
  [ActionIcons.add]: MAWB_RPE_ADD_MANIFEST_ACTION,
  [ActionIcons.delete]: MAWB_RPE_REMOVE_MANIFEST_ACTION,
};

/** Tab ids from SM Roles & Permissions (MAWB Information page). */
export const MAWB_RPE_MISCELLANEOUS_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.miscellaneous;
export const MAWB_RPE_STATUSCODES_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.statuscodes;
export const MAWB_RPE_NOTES_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.notes;
export const MAWB_RPE_ATTACHMENTS_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.attachments;
/** SM field-level tabs on MAWB Information (module-scoped; same tabId numbers as Shipment AP/AR). */
export const MAWB_RPE_AR_TAB_ID = 130;
export const MAWB_RPE_AP_TAB_ID = 131;

export const MAWB_RPE_PAGE_FORM_SCOPE = rpeTabFormScope(
  MAWB_RPE_INVALID_TAB_AND_LEGEND_ID
);
export const MAWB_RPE_MISCELLANEOUS_FORM_SCOPE = rpeTabFormScope(
  MAWB_RPE_MISCELLANEOUS_TAB_ID
);
export const MAWB_RPE_STATUSCODES_FORM_SCOPE = rpeTabFormScope(
  MAWB_RPE_STATUSCODES_TAB_ID
);
export const MAWB_RPE_NOTES_FORM_SCOPE = rpeTabFormScope(MAWB_RPE_NOTES_TAB_ID);
export const MAWB_RPE_ATTACHMENTS_FORM_SCOPE = rpeTabFormScope(
  MAWB_RPE_ATTACHMENTS_TAB_ID
);
export const MAWB_RPE_AR_FORM_SCOPE = rpeTabFormScope(MAWB_RPE_AR_TAB_ID);
export const MAWB_RPE_AP_FORM_SCOPE = rpeTabFormScope(MAWB_RPE_AP_TAB_ID);
